import { activeFrontendLocales } from '@pkg/config/languages';
import type { LOCALE_CODE } from '@pkg/config/languages/localeCodes';

export interface SlugParts {
  greatGrandParent: string | null;
  grandParent: string | null;
  parent: string | null;
  slug: string;
}

/**
 * From a URL path (e.g. /en-gb/about-us/our-history), get path parts without locale
 * (e.g. ['about-us', 'our-history']).
 */
export function urlToPathParts(path: string): Array<string> {
  const pathParts = path.toLowerCase().split('/').filter(part => part);

  if (activeFrontendLocales.includes(pathParts[0] as LOCALE_CODE)) {
    pathParts.shift();
  }

  return pathParts;
}

/**
 * From path parts (e.g. ['about-us', 'our-history']), get slug parts for Sanity.
 * Supports up to 3 levels of nesting (parent / grandParent / greatGrandParent).
 */
export function pathPartsToSlugParts(pathParts: Array<string>): SlugParts {
  const defaultResult: SlugParts = {
    greatGrandParent: null,
    grandParent: null,
    parent: null,
    slug: '/',
  };

  if (pathParts.length > 4) {
    pathParts = pathParts.slice(0, 4);
  }

  return {
    ...defaultResult,
    greatGrandParent: pathParts.length === 4 ? pathParts[0] : null,
    grandParent: pathParts.length >= 3 ? pathParts[pathParts.length - 3] : null,
    parent: pathParts.length >= 2 ? pathParts[pathParts.length - 2] : null,
    slug: pathParts[pathParts.length - 1],
  };
}
